<template>
<div>
  <fade-in>
<p class="work-contents-text">社内のカリキュラム「チーム制作」で作成した架空の店{{ webSiteText }}のWebサイトです。</p>
  </fade-in>
  <fade-in>
<p class="work-contents-text">チーム制作とは「企画、情報設計、デザイン、レスポンシブコーディング」と実践に近い体験を通してデザイナー・ディレクターを養成する講座のことで、</p>
<ul>
  <li>ディレクター</li>
  <li>デザイナー</li>
  <li>コーダー</li>
</ul>
<p>とチーム内の担当者に分かれて、Webサイトを制作するものです。</p>
  </fade-in>
  <fade-in>
<p class="work-contents-text">私は、この社内カリキュラムで「コーダー」としてWebサイトの制作に関わりました。</p>
  </fade-in>
  <fade-in>
<p class="work-contents-text">以下、担当したコンテンツ箇所になります。</p>
  </fade-in>
</div>
</template>

<script>
import FadeIn from '@/components/FadeIn.vue';

export default {
 props: ['webSiteText'],
  components: {
    FadeIn
  }
}
</script>

<style lang="scss" scoped>
.work-contents-text {
  margin-top: 100px;
}
</style>